// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"307":"854830c2","380":"fd99374c","428":"fd99374c"}[chunkId] + ".chunk.css";
};